/**
 * Block: new-hero-general (type3 slider + modal)
 *
 * Handles:
 * - Toggle hero items slider overlay (click card → open slider)
 * - Close slider button
 * - Modal toggle inside slider items (show-modal / go-back)
 * - Body scroll lock when slider is active
 */

export function init() {
    // Toggle hero item slider — clicking type3 cards opens the fullscreen slider
    const toggleButtons = document.querySelectorAll('.toggle-hero-item-slider');
    if (!toggleButtons.length) return;

    toggleButtons.forEach((button) => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            const index = this.getAttribute('data-number');
            const slider = document.getElementById('hero-items-slider');
            if (!slider) return;

            // Activate slider overlay
            document.body.classList.add('hero-items-slider-active');

            // Initialize slick if not already initialized
            if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
                const $slider = jQuery('#hero-items-slider .hero-items-slider-container');
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.slick({
                        dots: true,
                        arrows: true,
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '0px',
                        adaptiveHeight: true,
                    });
                }
                // Go to the clicked slide
                $slider.slick('slickGoTo', parseInt(index, 10));
            }
        });
    });

    // Close slider button
    document.addEventListener('click', function (e) {
        const closeBtn = e.target.closest('.close-btn-hero-items-slider');
        if (closeBtn) {
            e.preventDefault();
            document.body.classList.remove('hero-items-slider-active');
            // Remove any show-modal states
            document.querySelectorAll('.hero-items-slider-item').forEach((item) => {
                item.classList.remove('show-modal');
            });
        }
    });

    // Modal toggle — buttons with href="#show-modal" inside slider items
    const sliderButtons = document.querySelectorAll('.hero-items-slider-item .button');
    if (sliderButtons.length) {
        sliderButtons.forEach((btn) => {
            if (btn.getAttribute('href') === '#show-modal') {
                btn.addEventListener('click', function (e) {
                    e.preventDefault();
                    const number = this.getAttribute('data-number');
                    const sliderItem = this.closest('.hero-items-slider-item');

                    // Clear all modal states
                    document.querySelectorAll('.hero-items-slider-item').forEach((item) => {
                        item.classList.remove('show-modal');
                    });

                    // Move modal content into the slider item's container
                    const modalContent = document.getElementById('hero-items-slider-modal-' + number);
                    if (modalContent && sliderItem) {
                        const container = sliderItem.querySelector('.right-panel-modal-container--inner');
                        if (container) {
                            container.appendChild(modalContent);
                        }
                        sliderItem.classList.add('show-modal');
                    }
                });
            }
        });
    }

    // Go-back button inside modals
    document.querySelectorAll('.go-back-btn-modal').forEach((btn) => {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelectorAll('.hero-items-slider-item').forEach((item) => {
                item.classList.remove('show-modal');
            });
        });
    });
}
